export const environment = {
  production: true,
  apiUrl: "https://umyomilitary.site/api_umyocards/public/api/"
};


